module.exports = __webpack_public_path__ + "static/media/single_scan_view.0c0ba95b.png";